import { FleekError } from './FleekError';

type FleekFunctionWasmEncryptionFailedErrorOptions = Record<string, never>;

export class FleekFunctionWasmEncryptionFailedError extends FleekError<FleekFunctionWasmEncryptionFailedErrorOptions> {
  public name = 'FleekFunctionWasmEncryptionFailedError';

  toString = () => {
    return `Unable to encrypt WASM code for Fleek function`;
  };
}
